import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Let's talk about filter bubbles",
  "description": "",
  "published": "2016-11-11T00:00:00.000Z",
  "redirect_from": ["/blog/filter-bubbles-echo-chambers/swizec/7205"],
  "categories": "Opinions, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There's been a lot of talk of filter bubbles and echo chambers. `}<a parentName="p" {...{
        "href": "http://graphics.wsj.com/blue-feed-red-feed/#/president-trump"
      }}>{`The blue feed this, the red feed that`}</a>{`. The media is biased, the facebook ruined information, the twitter is a cesspool, The Result is `}<em parentName="p">{`their fault`}</em>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://techcrunch.com/2016/11/10/facebook-admits-it-must-do-more-to-stop-the-spread-of-misinformation-on-its-platform/"
      }}>{`Facebook must change!`}</a>{` Twitter must change! `}<em parentName="p">{`Media`}</em>{` must change!`}</p>
    <p>{`Here is a truth:`}</p>
    <lite-youtube {...{
      "videoid": "5vBGOrI6yBk",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Here is another truth:`}</p>
    <lite-youtube {...{
      "videoid": "HFvT_qEZJf8",
      "videostartat": "0"
    }}></lite-youtube>
    <blockquote>
      <p parentName="blockquote">{`Television is not the truth! Television is a God-damned amusement park! Television is a circus, a carnival, a traveling troupe of acrobats, storytellers, dancers, singers, jugglers, side-show freaks, lion tamers, and football players. We're in the boredom-killing business!`}</p>
    </blockquote>
    <p>{`Replace television with social media, most of the internet, hell, even traditional newspapers, and you'll get the situation we find ourselves in.`}</p>
    <p>{`All media is the same entertaining shit. Designed to please your ego, validate your beliefs, and never to upset you. Unless, of course, upsetting you boils down to `}<em parentName="p">{`"See how bad your life `}<strong parentName="em">{`could`}</strong>{` be but isn't? Go you!"`}</em></p>
    <p>{`This is not a consequence of some vast conspiracy, of The Man suppressing dissent. It's an emergent result of what `}<em parentName="p">{`you`}</em>{` (and I) enjoy. The result of our collective preference, if you will.`}</p>
    <p>{`Fundamentally, people want to be entertained, not informed, validated, not challenged.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Fundamentally the problem is people want to be `}<br parentName="p"></br>{`entertained, not informed, `}<br parentName="p"></br>{`coddled and validated, not challenged.`}<br parentName="p"></br><br parentName="p"></br>{`FB/TW is just a symptom.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/796772354592382976"
      }}>{`November 10, 2016`}</a></blockquote>
    <p>{`Facebook, Twitter, click-based journalism, television, and the media in general, they're all just symptoms of our collective laziness. They do all they can to keep us engaged and coming back. They don't care about informing you, and you don't care about being informed. You think you do, but that's not what you click on.`}</p>
    <p>{`And why would you?`}</p>
    <p>{`It's tiring to always fight for your beliefs. It's exhausting to defend your viewpoint. It's frustrating that two people can fundamentally disagree and still both be right.`}</p>
    <blockquote>
      <p parentName="blockquote">{`There are several cognitive biases (among them `}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/Illusory_truth_effect%0A"
        }}>{`the illusory truth effect`}</a>{`, `}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/Confirmation_bias"
        }}>{`confirmation bias`}</a>{`, `}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/Bandwagon_effect"
        }}>{`the bandwagon effect`}</a>{`, and `}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/Congruence_bias"
        }}>{`congruence bias`}</a>{`) that make people engage more strongly with ideas that fit their preconceptions and discount ideas that don’t.`}</p>
    </blockquote>
    <p>{`This leads to echo chambers. We each become wrapped in our own little bubble where the world agrees with us, we're always right, and Those Others™ are just too dumb and delusional to know any better.`}</p>
    <p><em parentName="p">{`They`}</em>{` think `}<em parentName="p">{`you're`}</em>{` just as dumb and delusional as `}<em parentName="p">{`you`}</em>{` think `}<em parentName="p">{`they`}</em>{` are.`}</p>
    <p>{`So what can you do?`}</p>
    <p>{`Seek disagreement. Click links you hate. Like and heart and comment on posts you think are crazy, backwards, and dumb. `}<em parentName="p">{`Train`}</em>{` the algorithms to give you everything. Show the journalists that they should cover all angles.`}</p>
    <p>{`Yes, this will make your Facebook and Twitter and the rest "worse". It will make your life harder and the internet less fun. But remember: when two people always agree, one of them is unnecessary.`}</p>
    <p>{`Become friends with people you disagree with.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      